import api from '../services/Api';

export const fetchSubscriptions = async businessId => {
  try {
    const response = await api.get(`/subscriptions/business/${businessId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching subscriptions:', error);
    return { subscriptions: [] };
  }
};

export const transformSubscriptionsToTransactions = subscriptions => {
  return subscriptions?.map(sub => ({
    description: sub?.planType,
    id: `${sub?.paystackSubscriptionCode}`,
    type: 'Subscription',
    date: new Date(sub?.startDate).toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }),
    amount: `$${sub.planDetails?.price?.toFixed(2)}`,
    status: sub?.status,
    paymentStatus: sub?.paymentStatus,
  }));
};
